import Formatting from "../../foundation/Formatting";
import React from "react";
import File from "../../types/files/File";
import {
    FileExplorerType,
    FileExplorerTypes,
} from "../../types/system/FileExplorer";
import FileExplorerDialogLevel from "./FileExplorerLevel";

interface FileExplorerEntryProps {
    type: FileExplorerType;
    data: File;
    allData: File[];
    selected: File;
    onClick: (data: File) => void;
}

interface FileExplorerEntryState {
    expanded: boolean;
}

class FileExplorerEntry extends React.Component<
    FileExplorerEntryProps,
    FileExplorerEntryState
> {
    state = {
        expanded: true,
    };

    canSelect() {
        switch (this.props.data.fileType.toUpperCase()) {
            case "TIMETABLEFILE":
                return (
                    this.props.type === FileExplorerTypes.Timetables ||
                    this.props.type === FileExplorerTypes.Files
                );
            case "STUDENTOPTIONSFILE":
                return (
                    this.props.type === FileExplorerTypes.StudentOptions ||
                    this.props.type === FileExplorerTypes.Files
                );
            case "DAILYORGANISERFILE":
                return (
                    this.props.type === FileExplorerTypes.DailyOrganisers ||
                    this.props.type === FileExplorerTypes.Files
                );
            case "FOLDER":
                return (
                    this.props.type === FileExplorerTypes.Any ||
                    this.props.type === FileExplorerTypes.Folders
                );
            default:
                return false;
        }
    }

    isSelected() {
        return this.props.selected === this.props.data;
    }

    render() {
        return (
            <>
                <div
                    className={`entry ${Formatting.toClassName(
                        this.props.data.fileType ?? "",
                    )}${this.isSelected() ? " selected" : ""}${
                        this.canSelect() ? " selectable" : ""
                    }`}
                    tabIndex={0}
                    onClick={() => {
                        if (this.canSelect())
                            this.props.onClick(this.props.data);
                    }}
                    data-contextkey="file-explorer-item"
                    data-contextvalue={this.props.data.fileType + ":" + this.props.data.id + ":" + this.props.data.name}>
                    <span
                        className={`expander${
                            this.props.data.fileType === "Folder"
                                ? " folder"
                                : ""
                        }${this.state.expanded ? " expanded" : ""}`}
                        tabIndex={0}
                        onClick={() =>
                            this.setState(prev => ({
                                expanded: !prev.expanded,
                            }))
                        }></span>
                    <span className="icon"></span>
                    <span className="name">
                        {this.props.data.folderId === 0
                            ? "TDS"
                            : this.props.data.name}
                    </span>
                </div>
                {this.props.data.fileType === "Folder" && (
                    <FileExplorerDialogLevel
                        className={
                            this.state.expanded ? "expanded" : "collapsed"
                        }
                        type={this.props.type}
                        parentId={this.props.data.id}
                        allData={this.props.allData}
                        selected={this.props.selected}
                        onClick={data => this.props.onClick(data)}
                    />
                )}
            </>
        );
    }
}

export default FileExplorerEntry;
